module.exports = __webpack_public_path__ + "images/5199db7f6a986ea1e29bbb397912aaa55f3641df2dfb5100e4f3247cab81829e.svg";